import { useEffect, useState, useCallback } from 'react';

export const useCopyToClip = (): [boolean, () => void] => {
  const [isCopied, setIsCopied] = useState<boolean>(false);

  useEffect(() => {
    let timerId: ReturnType<typeof setTimeout> | null = null;

    if (isCopied) {
      timerId = setTimeout(() => {
        setIsCopied(false);
        (document.activeElement as HTMLElement | null)?.blur();
      }, 1000);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [isCopied]);

  const handleCopy = useCallback(() => setIsCopied(true), []);

  return [isCopied, handleCopy];
};
